import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputPasswordProps } from './types';
import { generateSimpleRequiredOptionalPlaceholder } from '../utils';

// components
import { InputPassword } from '@ui';

const FormInputPassword: React.FC<FormInputPasswordProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generateSimpleRequiredOptionalPlaceholder(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <InputPassword {...rest} placeholder={placeholder} />;
};

export default React.memo(FormInputPassword);
